<template>
	<div class="card">
		<div class="image-content">
			<slot name="imageSlot" />
		</div>
		<div class="text-content">
			<slot name="contentSlot" />
		</div>

		<slot name="default" />
	</div>
</template>

<script setup>
defineProps({
	data: {
		type: Object,
		required: false,
		default: () => ({}),
	}
})
</script>

<style lang="scss" scoped>
.card {
	position: relative;
	display: flex;
	flex-flow: column nowrap;
	height: 100%;
}

.image-content {
	position: relative;
	display: flex;
	overflow: hidden;
	width: 100%;
}

.text-content {
	position: relative;
	display: flex;
	flex-flow: column nowrap;
	flex-grow: 2;
	align-items: stretch;
	width: 100%;
}
</style>